// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';
import selectPage from './modules/selectPage';
import tooltip from './modules/tooltip';
import contextMenu from './modules/contextMenu';
import postCreator from './modules/postCreator';
import storification from './modules/storification';
import users from './modules/users';
import planner from './modules/planner';


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        selectPage,
        tooltip,
        contextMenu,
        postCreator,
        storification,
        users,
        planner
    },
});